import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function Proof() {
  return <section className="py-24 px-6" data-id="element-134">
      <div className="max-w-3xl mx-auto" data-id="element-135">
        <FadeIn data-id="element-136">
          <div className="relative p-8 md:p-12 bg-white border border-[#E5E0D8] rounded-sm" data-id="element-137">
            <div className="absolute -top-4 left-8 bg-[#FAF7F2] px-4 text-sm font-bold tracking-widest uppercase text-[#C26D5C]" data-id="element-138">
              Lo que cambia en 7 días
            </div>
            <p className="font-serif text-2xl md:text-3xl text-[#1C1917] leading-relaxed mb-6" data-id="element-139">
              "Notarás que tu reactividad emocional disminuye. Los problemas que
              antes te causaban taquicardia ahora se sienten como tareas
              gestionables."
            </p>
            <p className="text-[#4A4541] text-lg" data-id="element-140">
              Tu energía deja de ser una montaña rusa y se convierte en un flujo
              constante.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}